import MyReferrals from './MyReferrals';

export default MyReferrals;
